'use strict';

var _createForOfIteratorHelper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var internals = {
  suspectRx: /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*\:/
};

exports.parse = function (text, reviver, options) {
  // Normalize arguments
  if (!options) {
    if (reviver && typeof reviver === 'object') {
      options = reviver;
      reviver = undefined;
    } else {
      options = {};
    }
  } // Parse normally, allowing exceptions


  var obj = JSON.parse(text, reviver); // options.protoAction: 'error' (default) / 'remove' / 'ignore'

  if (options.protoAction === 'ignore') {
    return obj;
  } // Ignore null and non-objects


  if (!obj || typeof obj !== 'object') {
    return obj;
  } // Check original string for potential exploit


  if (!text.match(internals.suspectRx)) {
    return obj;
  } // Scan result for proto keys


  exports.scan(obj, options);
  return obj;
};

exports.scan = function (obj, options) {
  options = options || {};
  var next = [obj];

  while (next.length) {
    var nodes = next;
    next = [];

    var _iterator = _createForOfIteratorHelper(nodes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;

        if (Object.prototype.hasOwnProperty.call(node, '__proto__')) {
          // Avoid calling node.hasOwnProperty directly
          if (options.protoAction !== 'remove') {
            throw new SyntaxError('Object contains forbidden prototype property');
          }

          delete node.__proto__;
        }

        for (var key in node) {
          var value = node[key];

          if (value && typeof value === 'object') {
            next.push(node[key]);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};

exports.safeParse = function (text, reviver) {
  try {
    return exports.parse(text, reviver);
  } catch (ignoreError) {
    return null;
  }
};